const clean = (value) => String(value || "").trim();

export function describeProfessionalConnectionRequestRecovery(connection = {}, currentUserId = "") {
  const connectionId = clean(connection.connection_id);
  const status = clean(connection.connection_status).toLowerCase();
  const direction = clean(connection.connection_direction).toLowerCase();
  const actorUserId = clean(currentUserId);
  return {
    connectionId,
    status,
    direction,
    actorUserId,
    eligible: Boolean(actorUserId && connectionId && status === "pending" && direction === "outgoing"),
  };
}

export function createProfessionalConnectionRequestRecoveryGuard() {
  const inFlight = new Set();
  const completed = new Set();

  return {
    begin(recovery) {
      if (!recovery?.eligible) return { started: false, reason: "not_eligible" };
      if (completed.has(recovery.connectionId)) return { started: false, reason: "completed" };
      if (inFlight.has(recovery.connectionId)) return { started: false, reason: "in_flight" };
      inFlight.add(recovery.connectionId);
      return { started: true, reason: "started" };
    },
    finish(connectionId, { success = false } = {}) {
      const id = clean(connectionId);
      inFlight.delete(id);
      if (success && id) completed.add(id);
      return this.snapshot(id);
    },
    snapshot(connectionId = "") {
      const id = clean(connectionId);
      return {
        inFlight: id ? inFlight.has(id) : false,
        completed: id ? completed.has(id) : false,
      };
    },
  };
}
